import classNames from "classnames";

import { CalendarEventIcon } from "@mwi/ui";

import { getTime } from "../utils/time";

const DateItem = ({
  date,
  className,
  "data-test-id": dataTestId,
}: {
  date: number | undefined;
  className?: string;
  "data-test-id"?: string;
}): JSX.Element | null => {
  if (!date) return null;

  return (
    <div
      className={classNames(
        "flex shrink-0 items-center gap-1 opacity-50",
        className,
      )}
    >
      <div className="self-start shrink-0 w-5 h-5 mobile:w-5 mobile:h-5">
        <CalendarEventIcon aria-hidden className="text-black" />
      </div>
      <p className="shrink-0 text-sm" data-test-id={dataTestId}>
        {getTime(date)}
      </p>
    </div>
  );
};

export default DateItem;
